import { Typography, Link } from "@mui/material";
import { Link as RouterLink } from 'react-router-dom';
import { push } from "connected-react-router";
import { FC, MouseEvent } from "react";
import { useLoginContext } from "@/pages/authentication/LoginContext";
import { useDispatch } from "react-redux";


export const CreateAccountLink : FC = () => {
  const { bag } = useLoginContext()
  const dispatch = useDispatch()
  return (
    <Typography variant="body2" color="textSecondary" sx={{ mb: 4 }} >
      Don't have an OnData account?
      {" "}
      <Link
        component={RouterLink}
        to="/register"
        onClick={(e: MouseEvent<HTMLAnchorElement>) => {
          e.preventDefault()
          dispatch(push("/register", { email: bag?.email }))
        }}
        underline="hover"
        variant="body2"
      >
        Create one now.
      </Link> 
    </Typography>
  )
}

export const ResetPasswordLink : FC = () => {
  const { bag } = useLoginContext()
  const dispatch = useDispatch()
  return (
    <Link
      component={RouterLink}
      to="/reset-password"
      onClick={(e: MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault()
        dispatch(push("/reset-password", { email: bag?.email }))
      }}
      underline="hover"
      variant="body2"
    >
      Forgot your password?
    </Link> 
  )
}